/*-----------------------------------------------------------------
- General translations
-----------------------------------------------------------------*/
export default {
    layout: {
        title      : 'یسناشاپ',
        separator  : '::',
        description: 'کوارک :: هسته‌ی قدرتمند یسناتیم',
    },

    404: {
        title       : 'صفحه‌ای که دنبال آن می‌گردید، وجود ندارد!',
        back_to_home: 'بازگشت به صفحه‌ی اصلی',
    },
    footer: {
        customer_services: 'خدمات مشتریان',
        store_name       : 'نام فروشگاه',
        contact_us       : '۷ روز هفته، ۲۴ ساعته پاسخگوی شما هستیم',
    },
    all_products: 'همه محصولات ',
};
